import { type FC, type ReactNode } from "react";

interface VisibleProps {
    when: boolean;
    children: ReactNode;
}

export const Visible: FC<VisibleProps> = ({ when, children }) => (when ? <>{children}</> : null);
